import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-daily-rewards-theme-asset-by-day',
  templateUrl: './daily-rewards-theme-asset-by-day.component.html',
  styleUrls: ['./daily-rewards-theme-asset-by-day.component.sass']
})
export class DailyRewardsThemeAssetByDayComponent {
  @Input() rows: any[] = [];
  @Input() field: any;
  @Output() onChange = new EventEmitter<any[]>();
  @Input() readonly: boolean = false;

  newDay: number | null = null;
  newThemeAsset: any = null;
  searchResults: any[] = [];
  errorMessage: string | null = null;

  constructor(private dataService: DataService) {}

  get sortedRows(): any[] {
    return [...(this.rows || [])].sort((a, b) => (a?.day ?? 0) - (b?.day ?? 0));
  }

  getThemeAssetName(row: any): string {
    return row?.themeAsset_ref?.name || '';
  }

  async searchThemeAssets(event: any) {
    const query = event.query ?? '';
    try {
      const numericId = query && !isNaN(Number(query)) ? Number(query) : null;
      const searchQuery = query
        ? { $or: [{ name: { $regex: query, $options: 'i' } }, ...(numericId !== null ? [{ id: numericId }] : [])] }
        : {};
      const result = await this.dataService.getAllOfTypeAsync(
        'theme-asset',
        {
          query: searchQuery,
          select: '_id id name',
          sort: { name: 1 },
        }
      );
      this.searchResults = result || [];
    } catch {
      this.searchResults = [];
    }
  }

  selectThemeAsset(event: any) {
    this.newThemeAsset = event?.value ?? event;
  }

  addRow() {
    this.errorMessage = null;

    if (!this.newDay || this.newDay < 1) {
      this.errorMessage = 'Enter a valid day (1 or greater).';
      return;
    }
    if (!this.newThemeAsset?._id) {
      this.errorMessage = 'Select a theme asset.';
      return;
    }
    if ((this.rows || []).some((r: any) => r.day === this.newDay)) {
      this.errorMessage = `Day ${this.newDay} is already assigned a theme asset.`;
      return;
    }

    const updated = [...(this.rows || []), { day: this.newDay, themeAsset_ref: this.newThemeAsset }];
    this.onChange.emit(updated);
    this.newDay = null;
    this.newThemeAsset = null;
    this.searchResults = [];
  }

  removeRow(day: number) {
    const updated = (this.rows || []).filter((r: any) => r.day !== day);
    this.onChange.emit(updated);
  }
}
